// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-content.chart > .recharts-responsive-container {
	transform: translate(-30px, 0px);
	width: 110%;
	/* scale: (1.3,0); */
}
.recharts-wrapper.chart {
	/* width: 100%; */
}

.recharts-wrapper.chart > .recharts-surface > .recharts-layer {
	/* transform: translate(0px, 0px); */
}
.recharts-wrapper.chart > .recharts-surface > .recharts-cartesian-grid {
	/* transform: translate(0px, 0px); */
}

/* margin and padding doesnt work on g elements */
.recharts-default-legend {
	margin: 10px;
}
.recharts-legend-wrapper {
	transform: translate(0px, -25px);
	padding: 0px;
}
.myLegend {
	position: absolute;
	top: 10;
	right: 0;
}

.recharts-layer.recharts-brush.myBrush > rect[fill="#fff"] {
	fill: var(--primary-color2);
	fill-opacity: 0.1;
}
.ybrush-wrap {
	position: absolute;
}

.recharts-layer.recharts-brush {
	/* transform: translate(0, -2px); */
}
.recharts-layer.recharts-brush .recharts-brush-slide {
	fill: var(--primary-color1) !important;
	fill-opacity: 1 !important;
}
.recharts-layer.recharts-brush-traveller rect {
	fill: var(--primary-color2);
}

.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {
	font-size: 0.8rem;
}
.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {
	font-size: 0.8rem;
}
.recharts-surface {
	/* transform: translate(0px, 0px); */
}
.chart-container {
	width: 100%; /* Adjust the width as needed */
	height: 100%; /* Adjust the height as needed */
	background-color: white; /* Change the background color as needed */
	position: relative; /* Use relative positioning */
}

.chartZoom {
	position: absolute;
	display: flex;
	top: 0;
	left: 0;
}

.error-container {
	display: flex;
	padding: 1rem;
	border: 0.1rem solid var(--primary-color1);
	border-radius: 2rem;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-items: center;
}
.error-container p {
	line-height: 1.6rem;
	font-size: 1.4rem;
	font-weight: bold;
	text-align: center;
}

@media (max-width: 380px) {
	.recharts-legend-wrapper {
		transform: translate(25px, -25px);
		padding: 0px;
		background: transparent;
	}
	.recharts-surface {
		/* transform: translate(0px, 0px); */
	}
	.legend-list span {
		font-size: 3.5vw;
	}
}
@media (min-width: 500px) {
	.chart-container {
		background-color: white;
	}
	.recharts-wrapper.chart {
		width: 100%;
	}
	/* margin and padding doesnt work on g elements */
	.recharts-default-legend {
		margin: 10px;
	}
	.recharts-legend-wrapper {
		transform: translate(20px, -30px);
	}
	.myLegend {
		position: absolute;
		top: 0;
		right: 0;
	}
	.recharts-layer.recharts-brush.myBrush > rect[fill="#fff"] {
		fill: var(--primary-color2);
		fill-opacity: 0.1;
	}

	.recharts-layer.recharts-brush {
		/* transform: translate(0, 4px); */
	}
	.recharts-layer.recharts-brush .recharts-brush-slide {
		fill: var(--primary-color1) !important;
		fill-opacity: 1 !important;
	}
	.recharts-layer.recharts-brush-traveller rect {
		fill: var(--primary-color2);
	}

	.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {
		font-size: 0.8rem;
	}
	.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {
		font-size: 0.8rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/Plotter/RechartsPlot.css"],"names":[],"mappings":"AAAA;CACC,gCAAgC;CAChC,WAAW;CACX,oBAAoB;AACrB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;AACrC;;AAEA,iDAAiD;AACjD;CACC,YAAY;AACb;AACA;CACC,gCAAgC;CAChC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;AACpC;AACA;CACC,sCAAsC;CACtC,0BAA0B;AAC3B;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,WAAW,EAAE,+BAA+B;CAC5C,YAAY,EAAE,gCAAgC;CAC9C,uBAAuB,EAAE,0CAA0C;CACnE,kBAAkB,EAAE,6BAA6B;AAClD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,MAAM;CACN,OAAO;AACR;;AAEA;CACC,aAAa;CACb,aAAa;CACb,0CAA0C;CAC1C,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC;EACC,iCAAiC;EACjC,YAAY;EACZ,uBAAuB;CACxB;CACA;EACC,oCAAoC;CACrC;CACA;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,WAAW;CACZ;CACA,iDAAiD;CACjD;EACC,YAAY;CACb;CACA;EACC,iCAAiC;CAClC;CACA;EACC,kBAAkB;EAClB,MAAM;EACN,QAAQ;CACT;CACA;EACC,2BAA2B;EAC3B,iBAAiB;CAClB;;CAEA;EACC,kCAAkC;CACnC;CACA;EACC,sCAAsC;EACtC,0BAA0B;CAC3B;CACA;EACC,2BAA2B;CAC5B;;CAEA;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".panel-content.chart > .recharts-responsive-container {\n\ttransform: translate(-30px, 0px);\n\twidth: 110%;\n\t/* scale: (1.3,0); */\n}\n.recharts-wrapper.chart {\n\t/* width: 100%; */\n}\n\n.recharts-wrapper.chart > .recharts-surface > .recharts-layer {\n\t/* transform: translate(0px, 0px); */\n}\n.recharts-wrapper.chart > .recharts-surface > .recharts-cartesian-grid {\n\t/* transform: translate(0px, 0px); */\n}\n\n/* margin and padding doesnt work on g elements */\n.recharts-default-legend {\n\tmargin: 10px;\n}\n.recharts-legend-wrapper {\n\ttransform: translate(0px, -25px);\n\tpadding: 0px;\n}\n.myLegend {\n\tposition: absolute;\n\ttop: 10;\n\tright: 0;\n}\n\n.recharts-layer.recharts-brush.myBrush > rect[fill=\"#fff\"] {\n\tfill: var(--primary-color2);\n\tfill-opacity: 0.1;\n}\n.ybrush-wrap {\n\tposition: absolute;\n}\n\n.recharts-layer.recharts-brush {\n\t/* transform: translate(0, -2px); */\n}\n.recharts-layer.recharts-brush .recharts-brush-slide {\n\tfill: var(--primary-color1) !important;\n\tfill-opacity: 1 !important;\n}\n.recharts-layer.recharts-brush-traveller rect {\n\tfill: var(--primary-color2);\n}\n\n.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {\n\tfont-size: 0.8rem;\n}\n.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {\n\tfont-size: 0.8rem;\n}\n.recharts-surface {\n\t/* transform: translate(0px, 0px); */\n}\n.chart-container {\n\twidth: 100%; /* Adjust the width as needed */\n\theight: 100%; /* Adjust the height as needed */\n\tbackground-color: white; /* Change the background color as needed */\n\tposition: relative; /* Use relative positioning */\n}\n\n.chartZoom {\n\tposition: absolute;\n\tdisplay: flex;\n\ttop: 0;\n\tleft: 0;\n}\n\n.error-container {\n\tdisplay: flex;\n\tpadding: 1rem;\n\tborder: 0.1rem solid var(--primary-color1);\n\tborder-radius: 2rem;\n\twidth: 100%;\n\theight: 100%;\n\talign-items: center;\n\tjustify-items: center;\n}\n.error-container p {\n\tline-height: 1.6rem;\n\tfont-size: 1.4rem;\n\tfont-weight: bold;\n\ttext-align: center;\n}\n\n@media (max-width: 380px) {\n\t.recharts-legend-wrapper {\n\t\ttransform: translate(25px, -25px);\n\t\tpadding: 0px;\n\t\tbackground: transparent;\n\t}\n\t.recharts-surface {\n\t\t/* transform: translate(0px, 0px); */\n\t}\n\t.legend-list span {\n\t\tfont-size: 3.5vw;\n\t}\n}\n@media (min-width: 500px) {\n\t.chart-container {\n\t\tbackground-color: white;\n\t}\n\t.recharts-wrapper.chart {\n\t\twidth: 100%;\n\t}\n\t/* margin and padding doesnt work on g elements */\n\t.recharts-default-legend {\n\t\tmargin: 10px;\n\t}\n\t.recharts-legend-wrapper {\n\t\ttransform: translate(20px, -30px);\n\t}\n\t.myLegend {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t}\n\t.recharts-layer.recharts-brush.myBrush > rect[fill=\"#fff\"] {\n\t\tfill: var(--primary-color2);\n\t\tfill-opacity: 0.1;\n\t}\n\n\t.recharts-layer.recharts-brush {\n\t\t/* transform: translate(0, 4px); */\n\t}\n\t.recharts-layer.recharts-brush .recharts-brush-slide {\n\t\tfill: var(--primary-color1) !important;\n\t\tfill-opacity: 1 !important;\n\t}\n\t.recharts-layer.recharts-brush-traveller rect {\n\t\tfill: var(--primary-color2);\n\t}\n\n\t.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {\n\t\tfont-size: 0.8rem;\n\t}\n\t.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {\n\t\tfont-size: 0.8rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
